import { api } from '$app/api';

export const getBookingsToAllocateToGarages = async (startDate) => {
  const { data } = await api.post('/allocations/garages/bookings', {
    startDate,
  });
  return data;
};
